<div>
    <app-header [title]="'myrewards.transaction_summary' | translate" (onBackLinkClick)="goBack()" [backLinkText]="'myrewards.go_back' | translate" />

    <!-- Bounded container -->
    <div class="max-w-screen-xl mx-auto px-4 py-8 grid grid-cols-1 lg:grid-cols-12 gap-6 bg-gray-50">
        <!-- COL: Main (left, col-span-8 on desktop) -->

        <!-- Transaction Summary -->
        <div class="bg-white p-4 col-span-12">

                <div class="grid grid-cols-12 gap-4">
                  <div class="flex flex-col gap-4 items-start col-span-12 md:col-span-4 lg:col-span-3" *ngFor="let item of redeemedRewards">
                      <img src="https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/actios/images/giftcard-desktop.png" alt="Reward" class="w-full object-cover" />
                      <div>
                            <span class="typography-body-m-regular">{{item.name}}</span><br/>
                            <span class="typography-body-s-regular text-primary">{{item.pointCost}} {{"myrewards.points" | translate}}</span><br/>
                            <div class="item__divider w-full"></div>
                            <span class="typography-body-s-regular textTerciary-color"> {{"myrewards.email" | translate}} </span><br/>
                            <span class="typography-body-m-regular">{{item.email}}</span><br/><br/>
                            <span class="typography-body-s-regular textTerciary-color"> {{"myrewards.date" | translate}} </span><br/>
                            <span class="typography-body-m-regular">{{getFormattedDate()}}</span><br/><br/>
                            <span class="typography-body-s-regular textTerciary-color"> {{"myrewards.orderNumber" | translate}} </span><br/>
                            <span class="typography-body-m-regular">{{item.orderNumber}}</span><br/><br/>
                            <span class="typography-body-s-regular textTerciary-color"> {{"myrewards.redeemedBy" | translate}} </span><br/>
                            <span class="typography-body-m-regular">{{item.contact}}</span><br/>
                      </div>
                  </div>
                </div>
        </div>
    </div>
</div>
